import React, { useEffect, useState } from "react";
import { pathAddAccount } from "../../../common/config/vars";
import IconChooseYourArea from "../../../common/assets/icons/chooseYourArea.png";
import "../styles/AccountPointsFilterBlock.css";
import { IAccountPoint } from "../../../common/accounts2";
import { cutText } from "../../../common/functions";
import { AskQ, AskQNotPressed, AskQOk } from "../../../common/ui/Popups/AskQuestion";
import { useHistory } from "react-router-dom";

interface IAccountPointsFilterPanel {
  accChoosedPointIdx: number,
  setAccChoosedPointIdx:  React.Dispatch<React.SetStateAction<number>>,
  accPoints: IAccountPoint[],
}

export const AccountPointsFilterPanel = ({ accChoosedPointIdx, accPoints, setAccChoosedPointIdx }: IAccountPointsFilterPanel) => {
  const [panelHidden, setPanelHidden] = useState<boolean>(true);
  const [panelTitle, setPanelTitle] = useState("");
  const [dialogState, setDialogState] = useState(AskQNotPressed);
  const [hideDialog, setHideDialog] = useState(true);
  const history = useHistory()
  const dialogTitle = "Не обнаружены аккаунты, по которым можно посмотреть точки" 
  const dialogText = "Хотите перейти в раздел для добавления аккаунта?"

  const onAccPointClicked = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    //@ts-ignore
    setAccChoosedPointIdx(e.target.parentElement.value)
    setPanelHidden(true)
  }

  const onTitleClicked = () => {
    if(accPoints.length == 0) {
      setHideDialog(false)
    } else {
      setPanelHidden(!panelHidden)
    }
  }

  const onShowAllAreaClicked = () => {
    setAccChoosedPointIdx(-1)
    setPanelHidden(true)
  }

  useEffect(() => {
    if(accChoosedPointIdx == -1) {
      setPanelTitle("Все площадки")
    } else if(accChoosedPointIdx < accPoints.length) {
      setPanelTitle(accPoints[accChoosedPointIdx].address)
    }
  }, [accChoosedPointIdx])

  useEffect(() => {
    if(dialogState == AskQOk) {
      setHideDialog(true)
      history.push(pathAddAccount)
    } else if(dialogState != AskQNotPressed) {
      setHideDialog(true)
      setDialogState(AskQNotPressed)
    }
  }, [dialogState])

  return (
    <>
    <div className="apfp-main"> 
      <div className={"apfp-title-con"} onClick={onTitleClicked}>
        <img src={IconChooseYourArea} style={{width: "18px", height: "18px"}}></img>
          <p className={"apfp-title"}>{panelHidden ? cutText(panelTitle, 37, "...", "") : "Выберите свою площадку"}</p>
        </div>
      <div hidden={panelHidden}>
        <p className={"apfp-point-all " + (accChoosedPointIdx == -1 ? " apfp-point-choosed" : "")} onClick={onShowAllAreaClicked}>Все площадки</p>
        <ul className="apfp-points-ul">
          {accPoints.map((p, i) => (
            <li key={i} value={i} className={"apfp-point" + (accChoosedPointIdx == i ? " apfp-point-choosed" : "")} onClick={onAccPointClicked} >
              <p className="apfp-point-label" >{p.address}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
    {hideDialog ? <></> : <AskQ askQ={dialogState} setAskQ={setDialogState} title={dialogTitle} text={dialogText}/>}
    </>
  );
};
